import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M9 13l3 -3l3 3","key":"svg-1"}]]

const IconSquareChevronUp = createReactComponent('outline', 'square-chevron-up', 'SquareChevronUp', __iconNode);

export default IconSquareChevronUp;